'use client';

import ImageComponent from "@/components/ui/ImageComponent"
import { GoArrowRight } from "react-icons/go";
import Link from "next/link";
import { usePathname } from "next/navigation";

const isExternalHref = (url: string) =>
    url.startsWith("http://") || url.startsWith("https://");

interface StaticPackageCardProps {
    slug: string,
    heading_text: string,
    description_text: string
    badges?: string[],
    badgesHeading?: string,
}

const StaticPackageCard = ({ heading_text, description_text, slug, badges, badgesHeading }: StaticPackageCardProps) => {

    const pathname = usePathname();
    const isStatic = slug === '_static-treatment';
    const href = isStatic
        ? undefined
        : slug
            ? isExternalHref(slug)
                ? slug
                : `${pathname.replace(/\/$/, '')}/${slug}`
            : '/';
    const openInNewTab = Boolean(href && isExternalHref(href));

    const content = (
        <div className="flex flex-col justify-start gap-2">
            <div className="space-y-6 h-auto">
                <div className={`space-y-2.5 flex flex-col justify-start  overflow-hidden text-ellipsis`}>
                    <h3 className="text-lightBrown font-semibold text-lg/[28px] text-start">{heading_text}</h3>
                    <p className={`text-textf1 text-sm/[25.6px] text-start min-h-12 leading-5 `}>
                        {description_text}
                    </p>
                </div>
            </div>
            {(badges?.length || !isStatic) ? <div className="min-h-[20px]">
                {isStatic ? <div className="h-6" /> :
                    <div className="group flex text-silverBlue font-semibold text-base items-center gap-1 cursor-pointer hover:opacity-90 mb-1">
                        <span>View details</span>
                        <span className="transition-transform duration-200 group-hover:translate-x-1">
                            <GoArrowRight className="font-bold" />
                        </span>
                    </div>}
            </div> : <></>}
        </div>
    );

    return isStatic ?
        (<div className="border-[1px] border-lightSliver p-3 rounded-3xl mx-2 h-fit md:h-full">
            {content}
        </div>)
        : (
            <div className="border-[1px] border-lightSliver p-3 rounded-3xl mx-2 h-fit md:h-full">
                <Link
                    href={href ?? '#'}
                    className="h-full"
                    {...(openInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                >
                    {content}

                </Link>
                {(badges && Array.isArray(badges) && badges.length) ?
                    <div className="border-t-1 border-dashed border-lightBrown pt-2 space-y-2 min-h-auto md:min-h-[80px]">
                        {(badgesHeading && badgesHeading.length) ? <div className="font-semibold">
                            {badgesHeading} Areas
                        </div> : <></>}
                        <div className="grid grid-cols-2 gap-2">
                            {
                                badges?.map((curr, index) => {
                                    let check = false;
                                    if (index + 1 == badges.length && (index + 1) % 2 != 0) check = true
                                    return (<span className={`${check ? "col-span-2" : "col-span-1"} border-lightBrown bg-primary border-1 rounded-md px-2 py-1 min-h-12 text-sm leading-5 font-bold flex items-center justify-center text-center`} key={`badges_${index + 1}`}>{curr}</span>)
                                })
                            }
                        </div>
                    </div>
                    : <></>}
            </div>
        );
}

export default StaticPackageCard